import { useTranslation } from '@/i18n'
import { AKEERA_AVATAR_SRC } from './constants'

/**
 * Chain-of-thought indicator: Akeera's avatar (pulsing ring) + three
 * bouncing dots + a status line that follows what the agent is actually
 * doing server-side (which tool is running). Shown while an answer is
 * streaming and no visible text has arrived yet.
 */

/** Tool name → status i18n key (namespace help_agent). */
const TOOL_STATUS_KEYS: Record<string, string> = {
  search_help_knowledge: 'status.searching',
  get_help_article: 'status.reading',
  get_route_map: 'status.checking_screens',
  help_action: 'status.taking_action',
}

export function statusKeyForTool(toolActivity: string | null): string {
  return (toolActivity && TOOL_STATUS_KEYS[toolActivity]) || 'status.thinking'
}

const ThinkingIndicator = ({ toolActivity }: { toolActivity: string | null }) => {
  const { t } = useTranslation('help_agent')
  return (
    <div className="flex items-center gap-2" data-testid="help-thinking-indicator">
      <span className="relative inline-flex size-6 shrink-0">
        <span className="absolute inset-0 animate-ping rounded-full bg-brand/30" />
        <img
          src={AKEERA_AVATAR_SRC}
          alt=""
          className="relative size-6 rounded-full object-cover ring-1 ring-brand/40"
        />
      </span>
      <div className="flex items-center gap-2 rounded-lg bg-gray-100 px-3 py-2 dark:bg-dark-accent">
        <span className="flex items-center gap-1" aria-hidden="true">
          <span className="size-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.3s]" />
          <span className="size-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.15s]" />
          <span className="size-1.5 animate-bounce rounded-full bg-gray-400" />
        </span>
        <span className="text-xs italic text-muted-foreground">
          {t(statusKeyForTool(toolActivity))}
        </span>
      </div>
    </div>
  )
}

export default ThinkingIndicator
